import { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Analytics from '../components/Analytics';
import PRCard from '../components/PRCard';
import { api } from '../api';
import './AnalyticsPage.css';

export default function AnalyticsPage({ user, onLogout }) {
  const [favExercises, setFavExercises] = useState([]);
  const [loadingFavs, setLoadingFavs] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        // 1) ids of favorites
        const favRes = await api('/me/favorites').catch(() => ({ exerciseIds: [] }));
        const ids = Array.isArray(favRes?.exerciseIds) ? favRes.exerciseIds : [];

        if (!ids.length) {
          if (alive) setFavExercises([]);
          return;
        }

        // 2) map id -> name from full exercise list
        const all = await api('/exercises');
        const nameById = new Map((all || []).map(e => [e.id, e.name]));

        const favs = ids.map(id => ({
          id,
          name: nameById.get(id) || 'Exercise',
        }));
        if (alive) setFavExercises(favs);
      } finally {
        if (alive) setLoadingFavs(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <>
      <Navbar user={user} onLogout={onLogout} tab="analytics" />

      <main className="page-wrapper">
        <div className="page-container">

          <div className="glass plan-glass">
          {/* Row 1: Chart first */}
          <section className="graph-section">
            <Analytics initialView="month" />
          </section>
          </div>

          {/* Row 2: PR tiles (favorites) */}
          <div className="glass plan-glass">
          <section className="analytics-cards-grid" aria-label="Personal records">
            {loadingFavs ? (
              <div className="pr-empty muted">Loading favorites…</div>
            ) : favExercises.length === 0 ? (
              <div className="pr-empty muted">
                No favorites yet. Mark exercises with ⭐ to see their PRs here.
              </div>
            ) : (
              favExercises.map((x) => (
                <PRCard
                  key={x.id}
                  exerciseId={x.id}
                  exerciseName={x.name}
                  unit="kg"
                  className="compact"
                />
              ))
            )}
          </section>
        </div>
        </div>
      </main>
    </>
  );
}